<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title">
        {{ isCreateDepartment ? ('departament.departament-form.new-department' | translate) : ('departament.departament-form.edit-department' | translate) }}
        </h4>
        <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="closeModal()"
        >
        <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div style="margin-bottom: 2rem !important;">
            <label for="name" class="form-label">{{ 'departament.departament-form.name-department' | translate }}</label>
            <input
                id="name"
                class="form-control"
                formControlName="name"
                [class.is-invalid]="form.get('name').invalid && form.get('name').touched"
            />
            <div class="invalid-feedback" *ngIf="form.get('name').touched && form.get('name').errors">
                <ng-container *ngIf="form.get('name').errors['minlength']">
                    {{ 'group.group-form.error.name' | translate }}
                </ng-container>
            </div>
        </div>

         <div class="d-flex justify-content-end">
            <button style="color: white !important;" class="btn btn-primary" type="submit" [disabled]="form.invalid || loading">
                 {{ loading
            ? (isCreateDepartment
                ? ('departament.departament-form.creating' | translate)
                : ('departament.departament-form.saving' | translate))
            : (isCreateDepartment
                ? ('project.createButton' | translate)
                : ('common.edit' | translate)) }}
            </button>
        </div>
    </form>
    </div>
</div>
